import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Compass, Brain, Briefcase, LineChart } from 'lucide-react';
import SEO from '../components/SEO';
import { PageHero, FeatureGrid, ProseSection, CTABand } from '../components/marketing';

const STEPS = [
  { Icon: Brain, title: '01 · Self-discovery', desc: 'Validated personality + strengths assessment so you make decisions on data, not vibes.', badge: 'Step one' },
  { Icon: Compass, title: '02 · Industry mapping', desc: 'We map your strengths to industries that are growing, paying and hiring globally.', badge: 'Step two' },
  { Icon: Briefcase, title: '03 · Program shortlist', desc: 'A handpicked shortlist of 8–12 programs ranked by fit, ROI and acceptance probability.', badge: 'Step three' },
  { Icon: LineChart, title: '04 · 5-year roadmap', desc: 'A written roadmap with milestones, target salaries and pivot points — yours to keep.', badge: 'Step four' },
];

export default function CareerPlanningPage() {
  return (
    <div className="bg-tge-paper min-h-screen">
      <SEO title="Career Planning — True Global Education" />
      <PageHero
        eyebrow="Career planning"
        title="Pick a future you can defend at any dinner table."
        intro="Most students pick a major, then hope a career follows. We do it the other way around — start with the life you want, then reverse-engineer the path."
      />
      <FeatureGrid items={STEPS} columns={2} />
      <ProseSection eyebrow="Why this matters" title="Switching majors costs $30k+ on average.">
        <p>
          A North American student loses an average of $30,000 and a year of their life when they switch
          majors mid-degree. Most of those switches happen because the original choice was made on guesswork.
          A few hours of structured career planning up front pays for itself many times over.
        </p>
      </ProseSection>
      <CTABand
        title="Book a career-planning session"
        body="One 90-minute deep dive can save years of zigzagging."
        primary={
          <Link
            to="/contact"
            className="bg-tge-gold hover:bg-tge-gold-soft text-tge-navy font-semibold px-7 py-3.5 rounded-full inline-flex items-center gap-2 transition"
          >
            Book now <ArrowRight size={17} />
          </Link>
        }
      />
    </div>
  );
}
